import { Button, Dialog, Grid, DialogTitle, DialogActions, DialogContent, IconButton, Icon, Slide } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';
import { useObservable, useCallbackObservable } from 'react-use-observable';
import ordersService from 'v2/services/orders';

import List from './list';

function Transition(props: any) {
  return <Slide direction='up' {...props} />;
}

const useStyle = makeStyles(() => ({
  root: {
    background: '#ffff',
    borderRadius: 4,
    width: '100%',
  },
  warning: {
    fontSize: 15,
    color: '#f50057',
  },
}));

const ModalTrackingCodes = () => {
  const classes = useStyle();
  const [open] = useObservable(() => ordersService.getModalTrackingCodes(), []);
  const [closeModal] = useCallbackObservable(() => ordersService.closeModalTrackingCodes(), []);

  return (
    <Dialog maxWidth={'lg'} TransitionComponent={Transition} aria-labelledby='tracking-modal' open={open} disableRestoreFocus>
      <DialogTitle id='dialog-title'>
        <>
          Status dos pedidos: AGUARDANDO ENVIO
          <IconButton size='small' style={{ float: 'right' }} onClick={closeModal}>
            <Icon color='primary'>close</Icon>
          </IconButton>
          <p className={classes.warning}>
            Ao enviar o código de rastreio o status da entrega será atualizado para <b>ENVIADO</b> automaticamente.
          </p>
        </>
      </DialogTitle>
      <DialogContent dividers>
        <div className={classes.root}>
          <List />
        </div>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={2} justify='flex-end'>
          <Grid item>
            <Button onClick={closeModal} color='primary'>
              Fechar
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};
export default ModalTrackingCodes;
